import { useEffect, type ReactNode } from "react";
import { applyTheme, getAppliedTheme } from "@/lib/theme";

interface ThemeProviderProps {
  children: ReactNode;
}

/**
 * Theme state lives on the `<html data-theme>` attribute and is observed by
 * `useTheme` via a `MutationObserver`, so this component intentionally does
 * no rendering or context wiring. Its only job is to reconcile the attribute
 * once on mount in case the pre-mount inline script in `index.html` was
 * stripped (Docker static-asset hardening, CSP) — under normal operation
 * this is a no-op because the attribute already matches.
 */
export function ThemeProvider({ children }: ThemeProviderProps) {
  useEffect(() => {
    applyTheme(getAppliedTheme());
  }, []);

  return <>{children}</>;
}
